<template>
	<div class="story-node" :style="nodeStyle" 
		@mousedown="handleMousedown"
		@mouseover="handleMouseOver"
		@mouseleave="handleMouseLeave"
		v-click-outside="hidePopover"
		v-bind:class="{selected: options.selected === id}">
		<div class="node-port node-input"
			@mousedown="inputMouseDown"
			@mouseup="inputMouseUp">
		</div>
		<div class="node-main">
			<component :is="iconComponent" :size="30"></component>
		</div>
		<div class="node-port node-output" 
			@mousedown="outputMouseDown">
		</div>
		<div v-show="show.edit" class="node-edit" @click.stop="show.editPopover = !show.editPopover">
			<img src="../assets/pencil.svg" class="pencil-image">
		</div>
		<div v-show="show.editPopover" class="popover-container">
			<button class="popover-btn" @click.stop="editDeviceTitle">Edit Device Title</button>
			<button class="popover-btn" @click.stop="deviceInfo">Device Info</button>
			<button class="popover-btn" @click.stop="deleteDevice">Delete Device</button>
		</div>
	</div>
</template>

<script>
	import CameraIcon from './icons/Camera.vue';
	import ControllerIcon from './icons/Controller.vue';
	import HandPointingRightIcon from './icons/HandPointingRight.vue';
	import LightbulbOutlineIcon from './icons/LightbulbOutline.vue';
	import MicrophoneIcon from './icons/Microphone.vue';
	import MonitorIcon from './icons/Monitor.vue';
	import NfcVariantIcon from './icons/NfcVariant.vue';
	import ProjectorIcon from './icons/Projector.vue';
	import ProjectorScreenIcon from './icons/ProjectorScreen.vue';

	export default {
		name: 'SpaceNode',
		components: {
			CameraIcon,
			ControllerIcon,
			HandPointingRightIcon,
			LightbulbOutlineIcon,
			MicrophoneIcon,
			MonitorIcon,
			NfcVariantIcon,
			ProjectorIcon,
			ProjectorScreenIcon
		},
		props: {
			iconComponent: {
				type: String
			},
			id: {
				type: Number,
				default: 1000,
				validator(val) {
					return typeof val === 'number'
				}
			},
			x: {
				type: Number,
				default: 0,
				validator(val) {
					return typeof val === 'number'
				}
			},
			y: {
				type: Number,
				default: 0,
				validator(val) {
					return typeof val === 'number'
				}
			},
			title: {
				type: String,
				default: 'Node Title'
			},
			description: {
				type: String,
				default: 'Default'
			},
			options: {
				type: Object,
				default() {
					return {
						centerX: 1024,
						scale: 1,
						centerY: 140,
					}
				}
			},
			show: {
				type: Object,
				default() {
					return {
						edit: false,
						editPopover: false
					}
				}
			}
		},
		computed: {
			nodeStyle() {
				return {
					top: this.options.centerY + this.y * this.options.scale + 'px', // remove: this.options.offsetTop + 
					left: this.options.centerX + this.x * this.options.scale + 'px', // remove: this.options.offsetLeft + 
					transform: `scale(${this.options.scale})`,
				}
			}
		},
		methods: {
			handleMousedown(e) {
				const target = e.target || e.srcElement;
				if (target.className.indexOf('node-input') < 0 && target.className.indexOf('node-output') < 0) {
					this.$emit('nodeSelected', e);
				}
				e.preventDefault();
				this.show.edit = false;
			},
			handleMouseOver() {
				this.show.edit = true;
			},
			handleMouseLeave() {
				this.show.edit = false;
			},
			outputMouseDown(e) {
				this.$emit('linkingStart')
				e.preventDefault();
			},
			inputMouseDown(e) {
				e.preventDefault();
			},
			inputMouseUp(e) {
				this.$emit('linkingStop')
				e.preventDefault();
			},
			hidePopover() {
				this.show.editPopover = false;
			},
			deleteDevice() {
				this.hidePopover();
				this.$emit('deleteDevice');
			},
			deviceInfo() {
				this.hidePopover();
				console.log('show device info');
			},
			editDeviceTitle() {
				this.hidePopover();
				console.log('edit device title')
			},
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	$themeColor: rgb(255, 136, 85);
	$portSize: 10;

	.story-node {
		margin: 0;
		width: 60px;
		position: absolute;
		box-sizing: border-box;
		border: 2px solid $themeColor;
		border-radius: 6px;
		color: #ffffff;
		z-index: 1;
		opacity: .9;
		cursor: move;
		transform-origin: top left;
		.node-main {
			text-align: center;
			position: relative;
			z-index: 5;
			min-height: 60px;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 30px;
			background-color: rgba(0,0,0,0.4);
		}
		.node-port {
			position: absolute;
			width: #{$portSize}px;
			height: #{$portSize}px;
			left: 50%;
			transform: translate(-50%);
			border: 2px solid $themeColor;
			border-radius: 100px;
			background: $themeColor;
			z-index: -1;
			&:hover {
				background: $themeColor;
				border: 1px solid #a6a6a6;
			}
		}
		.node-input {
			top: #{-2+$portSize/-2}px;
		}
		.node-output {
			bottom: #{-2+$portSize/-2}px;
		}
		.node-edit {
			position: absolute;
			right: -11px;
			top: -11px;
			font-size: 15px;
			width: 30px;
			height: 30px;
			color: $themeColor;
			cursor: pointer;
			background: white;
			border: 1px solid $themeColor;
			border-radius: 100px;
			text-align: center;
			z-index: 5;
			&:hover{
				background: #f2f2f2;
				color: white;
			}

			.pencil-image {
				width: 65%;
				height: 100%;
			}
		}
	}
	.selected {
		box-shadow: 0 0 2px 2px $themeColor;
	}
	.popover-container {
		position: absolute;
		top: 0;
		right: -164px;
		background-color: white;
		width: 150px;
		border: 1px solid #a3a5a8;
		border-radius: 4px;
	}
	.popover-btn {
		border: none;
		background: #a3a5a8;
		width: 100%;
		padding: 10px 0;
		color: white;
		font-family: inherit;
		font-size: 15px;
		cursor: pointer;
	}
	.popover-btn:hover {
		background-color: #3fa68b;
		transition: background-color 0.3s;
		cursor: pointer;
	}
</style>